<div class="back-container aza-primary-color aza-pa-flex-row aza-pa-no-gap">
    <mat-icon color="primary">chevron_left</mat-icon>
    <a routerLink="{{link}}" class="aza-primary-color" [queryParams]="queryParams" translate>{{text}}</a>
</div>
